// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__qZv+U","full":"loader_full__9forZ","ldsRipple":"loader_ldsRipple__tlwmx","lds-ripple":"loader_lds-ripple__-vRjl"};